// 巡回記録用の定数群
const SafetyDiariesConstants = {
  pageName: {
    safetyDiariesRegister: 'SafetyDiariesRegister', // 巡回記録新規登録
    safetyDiariesBulkRegister: 'SafetyDiariesBulkRegister', // 巡回記録一括登録
    safetyDiariesConfirm: 'SafetyDiariesConfirm', // 巡回記録詳細・編集
    safetyDiariesRecoveryRegister: 'SafetyDiariesRecoveryRegister', // 巡回記録是正報告
    safetyDiariesRecoveryApproval: 'SafetyDiariesRecoveryApproval', // 是正承認/否認
    safetyDiaries: 'SafetyDiaries', //巡回記録/各種連絡一覧
  },
  // 元請け系の記入者のプルダウンリスト
  journalType: {
    generalSafety: { id: 1, name: '統括安全衛生責任者' },
    originalSafety: { id: 2, name: '元方安全衛生管理者' },
    safetyOfficer: { id: 3, name: '安全担当者' },
    otherDirected: { id: 4, name: 'その他監督' },
  },
  // 元請けじゃない系の記入者のプルダウンリスト
  foremanJournalType: {
    safetyForeman: { id: 5, name: '安全担当職長' },
    otherForeman: { id: 6, name: 'その他職長' },
  },
  // 期間
  dataType: {
    // 記入日
    entriesDate: '1',
    // 是正報告日
    recoveryDate: '2',
    // 是正承認日
    finishDate: '3',
  },
  // 種別
  reportType: {
    pointOut: { id: 1, name: '指摘(巡回)' },
    wellKnown: { id: 2, name: '周知(巡回)' },
    other: { id: 3, name: 'その他(巡回)' },
    contact: { id: 4, name: '当日作業連絡' },
    otherContact: { id: 5, name: 'その他連絡' },
  },
  // 種別(未選択)
  noSelectReportType: { id: 0, name: '未選択' },
  // 指摘事項
  pointingOutType: {
    uncorrected: { id: 1, name: '未是正' },
    corrected: { id: 2, name: '是正済' },
    approved: { id: 3, name: '承認済' },
  },
  // 緊急度
  urgencyType: {
    low: { id: 1, name: '低' },
    middle: { id: 2, name: '中' },
    high: { id: 3, name: '高' },
    emergency: { id: 4, name: '緊急' },
  },
  // 通知対象フラグ
  noticeFlag: {
    off: { id: 0 },
    on: { id: 1 },
  },
  // 安全衛生日誌フラグ
  printDiaryFlag: {
    off: { id: 0 },
    on: { id: 1 },
  },
  // 上限ファイルサイズ(バイト)
  maxFileSize: {
    single: 10485760, // 10MB
    multi: 7340032, // 7MB
  },
  keyLwId: ['lw_talkroom_ids', 'direct_talkroom_ids'],
};

export default SafetyDiariesConstants;



// WEBPACK FOOTER //
// ./src/utilities/safetyDiariesConstants.js